import { Box, Text, Button } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { formatDate } from "../../redux/actions/actions";
import { deleteTopic } from "../../redux/api_calls/apiCalls";
import IndividualTopicCard from "./IndividualTopicCard";
const extensions = ['mp4', 'm1v', 'ogg', 'mov', 'qt', 'webm', 'm4v', 'wmv', 'avi']

export default function AllTopics({ topics, method, loadMoreVisible }) {
    const dispatch = useDispatch()
    console.log(topics)
    const deleteHandler = (id) => {
        let updatedTopics = topics.filter((topic) => topic.id !== id)
        dispatch(deleteTopic(updatedTopics, id))
    }

    const getFileType = (contentLink) => {
        return extensions.includes(contentLink.substring(contentLink.lastIndexOf('.') + 1))
    }

    return (
        <Box width={['95%', '95%', '95%', '80%']} flexDirection='column' justifyContent='space-between' alignItems='center' d={['none', 'none', 'none', 'flex']} mb='1.5rem'  >
            <Box d='flex' width='100%' p='1rem'>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='35%'>Topic</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Files</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Status</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Quizzes</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Actions</Text>
            </Box>
            {
                topics.map((topic) => <IndividualTopicCard
                    image={topic.cover_image}
                    name={topic.title}
                    dates={formatDate(topic.created_at.split(' ')[0])}
                    files={topic.file_count}
                    fileType = {getFileType(topic.content_url)}
                    quizzes={topic.quiz_count}
                    status={topic.status.toUpperCase() === 'Y'}
                    id={topic.id}
                    removeTopic={deleteHandler}
                    key={topic.id}
                    quizStatus = {topic.quiz_status}
                />)
            }
            {
                loadMoreVisible &&

                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={["12px", "14px", "16px", "18px"]}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                    onClick = {method}
                >
                    Load More...
                </Button>
            }
        </Box>
    )
}